"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFieldView = void 0;
var tslib_1 = require("tslib");
var IkeModel = tslib_1.__importStar(require("@ikegps/core-shared"));
var core_shared_1 = require("@ikegps/core-shared");
var input_1 = require("../../../components/input/input");
var number_input_state_1 = require("../../../components/input/number.input.state");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var page_state_1 = require("../../../state/page.state");
var field_info_1 = require("../../field.info/field.info");
function getValue(field, inputState) {
    var value = field.value;
    if (!field.hasValue()) {
        return null;
    }
    if (field.isManual() || field.isSag()) {
        return value;
    }
    if (field.isBearing() || field.isBackBearing()) {
        var angle = core_shared_1.IkeUnit.convertAngle(value, core_shared_1.IkeUnit.DEGREE, core_shared_1.IkeUnit.RADIAN);
        return core_shared_1.IkeUnit.round(angle, inputState.precision);
    }
    return null;
}
exports.NumberFieldView = {
    viewInline: function (field) {
        if (field.isSag()) {
            return core_shared_1.IkeUnit.display(field.value, services_1.Services.UserSettings.units);
        }
        return field.displayValue;
    },
    hasDetail: function (field) {
        return !field.isManual() && field.getCaptures().length > 0;
    },
    viewDetail: function (field) {
        if (!exports.NumberFieldView.hasDetail(field)) {
            return null;
        }
        var collection = field.collection;
        if (field.isSag()) {
            var sagCaptures = core_shared_1.CollectionModelFieldNumberSagUtil.getSagCaptures(field);
            var p2pMeasurement = core_shared_1.MultiPoint.Points([sagCaptures.start, sagCaptures.end]);
            var stats = [
                { name: i18n_1.T.DISTANCE_SAG, value: field.value },
                { name: i18n_1.T.DISTANCE_VECTOR, value: field_info_1.FieldInfo.viewVectorInline(p2pMeasurement) },
                { name: i18n_1.T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
                { name: i18n_1.T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal }
            ];
            return field_info_1.FieldInfo.viewCaptures(collection, tslib_1.__spreadArray(tslib_1.__spreadArray([sagCaptures.start], sagCaptures.points, true), [sagCaptures.end], false), stats);
        }
        var captures = field.getCaptures();
        return field_info_1.FieldInfo.viewCaptures(collection, captures);
    },
    viewEdit: function (field, ctrl) {
        if (field.isSag()) {
            return exports.NumberFieldView.viewInline(field, ctrl);
        }
        var inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new number_input_state_1.NumberInputState(field.schema.displayName);
            inputState.onValue(function () {
                field.Mutator.manual(inputState.value);
            });
            inputState.setValue(getValue(field, inputState));
            ctrl.changeState.addState(field.id, inputState);
        }
        var onmouseover = function () {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        var onmouseout = function () {
            page_state_1.CurrentState.setHoverId(null);
        };
        var className = input_1.Input.CSS.container;
        return (0, mithril_1.m)('div', { className: className, onmouseover: onmouseover, onmouseout: onmouseout, onclick: onclick }, [
            input_1.Input.view(inputState)
        ]);
    },
    hasClear: function (field) {
        return field.provider === IkeModel.CollectionModelFieldNumber.PROVIDER_SAG;
    }
};
//# sourceMappingURL=number.field.view.js.map